import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import moment from "moment";

const initialPaymentValues = {
  paymentId: "00000000-0000-0000-0000-000000000000",
  serviceTaskId: "00000000-0000-0000-0000-000000000000",
  serviceName: "",
  staffName: "",
  clientName: "",
  amount: "",
};

const PaymentModal = ({
  currentServiceTask,
  paymentModalVisible,
  setPaymentModalVisible,
  GetData,
  pageNumber,
}) => {
  const [paymentValues, setPaymentValues] = useState(initialPaymentValues);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentValues({
      ...paymentValues,
      [name]: value,
    });

    if (name === "amount" && value === "" ? false : true) {
      setErrors({ ...errors, amount: true });
    }
  };

  const validate = () => {
    let temp = {};
    temp.amount = paymentValues.amount === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    if (validate()) {
      const formData = new FormData();
      formData.append("paymentId", paymentValues.paymentId);
      formData.append("serviceTaskId", currentServiceTask.serviceTaskId);
      formData.append("serviceName", currentServiceTask.serviceName);
      formData.append("staffId", currentServiceTask.staffId);
      formData.append("clientId", currentServiceTask.clientId);
      formData.append("amount", paymentValues.amount);

      axios
        .post(config.APIACTIVATEURL + config.CREATEPAYMENT, formData, {
          ...headerconfig,
        })
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess("Payment Created");
            setPaymentModalVisible(false);
            resetPaymentForm();
            GetData(pageNumber);
          } else {
            handleError(res.data.message);
          }
        })
        .catch((error) => {
          handleError("Error in payment creating");
        });
    }
  };

  const resetPaymentForm = () => {
    setPaymentValues(initialPaymentValues);
    setErrors({});
    setIsSubmitted(false);
  };

  const applyErrorClass = (field) =>
    errors[field] === false && isSubmitted ? " form-control-danger" : "";

  return (
    <Modal
      show={paymentModalVisible}
      onHide={() => {
        resetPaymentForm();
        setPaymentModalVisible(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title> Create Payment</Modal.Title>
      </Modal.Header>
      <form onSubmit={handlePaymentSubmit}>
        <Modal.Body>
          <div className="form-group">
            <label>Amount</label>
            <input
              type="text"
              name="amount"
              className={"form-control" + applyErrorClass("amount")}
              value={paymentValues.amount}
              onChange={handlePaymentInputChange}
              placeholder="Enter Amount"
            />
            {errors.amount === false && isSubmitted && (
              <div className="validationerror">Please enter amount</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              resetPaymentForm();
              setPaymentModalVisible(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default PaymentModal;
